import React from 'react'
import UserProfileIcon from '../../images/icon-user-profile.svg'
import CloseIcon from '../../images/icon-close.svg'
import styled from 'styled-components'
import useComponentVisible from '../../utilities/useComponentVisible'
import ToggleSwitch from './toggle-switch'
import { TABLET, LAPTOP } from '../../utilities/breakpoints'
import { YOU_FILTER } from '../../utilities/helpers'
import { isEqual } from 'lodash-es'

const UserSettingsWidget = (props) => {
  const {
    showYourResults,
    onSetShowYourResults,
    filters,
    onSetFilters,
    useTranslate
  } = props;
  const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);

  const closeMenu = () => {
    setIsComponentVisible(false);
  }

  const handleshowYourResultsChange = (val) => {
    // If "you" is the current filter and we want to hide "you" results, we need to change the filter to "everyone"
    if (val === false) {
      if (isEqual(filters, YOU_FILTER)) {
        onSetFilters([]);
      }
    }

    onSetShowYourResults(val);
  }

  return (
    <WidgetContainer ref={ref} className={"user-settings"}>
      <ToggleButton onClick={() => setIsComponentVisible(!isComponentVisible)}>
        <img src={UserProfileIcon} alt="User settings" />
      </ToggleButton>
      {isComponentVisible &&
        <DropDown>
          <DropDownHeader>
            <h5>{useTranslate("user_settings.user_settings_title")}</h5>
            <CloseButton onClick={() => closeMenu()}><img src={CloseIcon} alt="Close" /></CloseButton>
          </DropDownHeader>
          <DropdownContent>
            <ToggleSwitch
              label={useTranslate("user_settings.hide_personal_results_label")}
              checked={showYourResults}
              onChange={(value) => handleshowYourResultsChange(value)}
              id={"hidePersonalResults"}
              description={useTranslate("user_settings.hide_personal_results_description")}
            />
          </DropdownContent>
        </DropDown>
      }
    </WidgetContainer>
  )
}

export default UserSettingsWidget;

const WidgetContainer = styled.div`
  position: relative;
  overflow: visible;
  width: 25px;
  height: 25px;
`;

const ToggleButton = styled.button`
  appearance: none;
  border: none;
  padding: 0;
  margin: 0;
  background: none;
  cursor: pointer;
  outline: none;
  
  img {
    width: 23px;
    height: auto;
    transition: all .3s ease-in-out;
  }
  
  &:hover,
  &:focus {
    img {
      filter: invert(75%) sepia(46%) saturate(6187%) hue-rotate(348deg) brightness(100%) contrast(93%);
    }
    outline: none;
  } 
  
  .nav-aftergame.inverse & {
    img {
      filter: invert(100%) sepia(100%) saturate(1%) hue-rotate(306deg) brightness(104%) contrast(101%);
    }
    
    &:hover,
    &:focus {
      img {
        filter: invert(75%) sepia(46%) saturate(6187%) hue-rotate(348deg) brightness(100%) contrast(93%);
      }
    } 
      
    @media${LAPTOP} {
      img {
        filter: none;
      }
    }
  }
`;

const DropDown = styled.div`
  position: absolute;
  top: 100%;
  right: -15px;
  width: 265px;
  height: auto;
  padding: 0;
  margin: 10px 0 0;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 1px 20px rgba(0, 0, 0, 0.15);
  z-index: 999;
  
  @media${TABLET} {
    right: -35px;
  }
`;

const DropDownHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  border-bottom: 1px solid #E4E7EB;
  padding: .75rem 1rem;
  color: #000;
  
  h5 {
    font-size: 16px;
    font-weight: 500;
    margin: 0;
    flex: 1 1 100%;
  }
  
  .close-button {
    flex: 0 0 20px;
  }
`;

const CloseButton = styled.button`
  appearance: none;
  border: none;
  padding: 0;
  margin: 0;
  background: none;
  cursor: pointer;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover,
  &:focus {
    img {
      filter: invert(75%) sepia(46%) saturate(6187%) hue-rotate(348deg) brightness(100%) contrast(93%);
    }
    outline: none;
  } 
`;

const DropdownContent = styled.div`
  padding: .75rem 1rem;
  color: #000;
`;


// WEBPACK FOOTER //
// ./src/components/ui/user-settings-widget.js